import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'

import './Settings.scss'
import useCheckMobileScreen from '../../common/hooks/use-check-mobile-screen-hook'
import {
    PAGE_CONST,
    PERMISSION_SCREEN,
    SETTINGS_CONST,
    SETTINGS_NAVIGATION_ITEMS
} from '../../common/constant/page-constant'
import MobileHeader from '../Common/Header/MobileHeader'
import SideMenu from '../Common/SideMenu/SideMenu'
import Header from '../Common/Header/Header'
import { useNavigate } from 'react-router-dom'
import { redirect } from '../../common/utils/redirectionUtils'
import {
    HEADER_CONFIG,
    HEADER_CONST
} from '../../common/constant/common-constant'

import ReminderSettings from './ReminderSettings'
import BankDetails from './BankDetails'
import MFSDetails from './MFSDetails'
import POSDetails from './POSDetails'
import LoanDetails from './LoanDetails'

const Settings = props => {
    const navigate = useNavigate()
    const isMobile = useCheckMobileScreen()
    const [activeItem, setActiveItem] = useState(SETTINGS_CONST.REMINDER_SETTINGS)
    const [permissions, setPermissions] = useState({})

    const headerOptions = {
        [HEADER_CONFIG.IS_BACK_VISIBLE]: true,
        [HEADER_CONFIG.TITLE]: HEADER_CONST.SETTINGS,
        [HEADER_CONFIG.HANDLE_BACK_FUNC]: () =>
            redirect(navigate, PAGE_CONST.HOME)
    }

    useEffect(() => {
        if (props.loginData.permissions) {
            let permission = props.loginData.permissions.filter(
                permission => permission.screen === PERMISSION_SCREEN.SETTINGS
            )[0]

            if (permission) setPermissions(permission)
        }
    }, [props.loginData])

    const handleItemClick = itemName => {
        setActiveItem(itemName)
    }

    return (
        <>
            {isMobile && <MobileHeader headerOptions={headerOptions} />}
            {!isMobile && <Header />}
            <SideMenu
                activeItem={PAGE_CONST.SETTINGS}
                component={PAGE_CONST.SETTINGS}
            />
            <div className="pageBody">
                <div className="settingsMenuWrapper">
                    <ul className="settingsMenuList">
                        {SETTINGS_NAVIGATION_ITEMS.map(item => (
                            <li
                                key={item.id}
                                className={`menuItem ${activeItem === item.name ? 'active' : ''}`}
                                onClick={() => handleItemClick(item.name)}>
                                {item.settingsDetailIcon}{' '}
                                <span>{item.name}</span>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="settingsContentWrapper">
                    {activeItem === SETTINGS_CONST.REMINDER_SETTINGS && (
                        <ReminderSettings
                            onBackClick={() => setActiveItem(undefined)}
                            permissions={permissions}
                        />
                    )}
                    {activeItem === SETTINGS_CONST.BANK_DETAILS && (
                        <BankDetails onBackClick={() => setActiveItem(undefined)} />
                    )}
                    {activeItem === SETTINGS_CONST.MFS_DETAILS && (
                        <MFSDetails onBackClick={() => setActiveItem(undefined)} />
                    )}
                    {activeItem === SETTINGS_CONST.POS_DETAILS && (
                        <POSDetails onBackClick={() => setActiveItem(undefined)} />
                    )}
                    {activeItem === SETTINGS_CONST.LOAN_DETAILS && (
                        <LoanDetails onBackClick={() => setActiveItem(undefined)} />
                    )}
                </div>
            </div>
        </>
    )
}

const mapStateToProps = state => {
    return {
        loginData: state.loginDataReducer?.loginData,
        alert: state.alertReducer.alert
    }
}

const mapDispatchToProps = dispatch => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(Settings)
